import { useMutation } from "@tanstack/react-query";
import fetcher from "src/utils/fetcher";

export const useCreateCheckoutSession = () => {
  return useMutation({
    mutationFn: async (amount: number): Promise<string> => {
      const response = await fetcher({
        url: "/api/inked/add_balance",
        method: "POST",
        body: { amount },
      });

      return response.data.clientSecret as string;
    },
  });
};
